import "./Subtitle.css";

const Subtitle = ({ children }) => {
  return <h2>{children}</h2>;
};

export default Subtitle;
